module.exports = __webpack_public_path__ + "static/media/mail.d89a4b4a.svg";